import axios from 'axios';

// let base_url = "";
// if(process.env.REACT_APP_STAGING === "prod") {
//     base_url = process.env.REACT_APP_BASE_URL
// } else {
//   base_url = process.env.REACT_APP_BASE_URL_TEST
// }

// const axiosCall = axios.create({
//     // baseURL: base_url
//     baseURL: "https://test-api.konnectbd.com/api/v1"
//     // baseURL: "http://127.0.0.1:4420/api/v1"
// })

// export default axiosCall;

const isProduction = process.env.REACT_APP_STAGING === 'prod';

const base_url = isProduction
  ? process.env.REACT_APP_BASE_URL || 'https://prod-api.konnectbd.com/api/v1'
  : process.env.REACT_APP_BASE_URL_TEST ||
    'https://test-api.konnectbd.com/api/v1';

const axiosCall = axios.create({
  baseURL: base_url,
  // baseURL: "http://127.0.0.1:4420/api/v1"
});

export default axiosCall;
